import { DSCircularButton } from "@components/design-system/molecules";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useNavigate } from "react-router";

export function SoapEditButton({ note }) {
  const navigate = useNavigate();

  return (
    <DSCircularButton
      title="Edit note"
      icon={faEdit}
      size="sm"
      variant="primary"
      onClick={() => {
        navigate(`/edit_note/${note?.uuid}`);
      }}
      dataTestId="edit-note-button"
    />
  );
}
